import React, { PropTypes } from 'react';
import L10n from './L10n';

const ArticleText = ({ item, lang }) => (
  <div className="bloc-texte" >
    {item.has('title') &&
      <h2><L10n lang={lang} item={item.get('title', '')} /></h2>}
    {item.has('subtitle') &&
      <p className="subtitle"><L10n lang={lang} item={item.get('subtitle', '')} /></p>}
    {item.has('texte') &&
      <p><L10n lang={lang} item={item.get('texte', '')} raw /></p>}
  </div>
);

ArticleText.propTypes = {
  item: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
};

export default ArticleText;



// WEBPACK FOOTER //
// ./common/components/ArticleText.js